import { store } from '../../store/store'
import * as types from '../../store/types'
import Pusher from 'pusher-js'
import Vue from 'vue'
import {API_URL} from '../../config'

//console.log(store.getters[types.CURRENT_USER])
export const initPusher = () => {
    console.log("pusher initialization...")
    if(store.getters[types.CURRENT_USER] && store.getters[types.CURRENT_USER].tenantApiKey){
        
        let socket = new Pusher('b40f2f85adff4d15dc79', {
          cluster: 'eu',
          authEndpoint: `${API_URL}/pusher/auth`,
          auth: {
            params: { apiKey: store.getters[types.CURRENT_USER].tenantApiKey },
            headers: {              
              'Authorization': `Bearer ${store.getters[types.USER_ACCESS_TOKEN]}`
            },
        
          },
          encrypted: true
        });
        
        Vue.prototype.$pusherSocket = socket;
        Vue.prototype.$pusher = { socket: socket, tenantApiKey: store.getters[types.CURRENT_USER].tenantApiKey, channels: {}}
        //presence: socket.subscribe(`presence-user-channel`) 
        registerChannel(`presence-user-channel`)
        
        Vue.prototype.$pusher.channels['presence-user-channel'].bind_global(function (event, data) {                                   
            let usersOnline = []
             Object.entries(Vue.prototype.$pusher.channels['presence-user-channel'].members.members).forEach(item => {                 
                  usersOnline.push(item[1])
             })
             store.dispatch(types.USERS_ONLINE,  usersOnline)            
         })     
        //Vue.prototype.$presenceChannel = socket.subscribe('presence-user-channel');        
    }    
}

export const registerChannel = (name, options) => {    
    if(options && options.noTenant){
      Vue.prototype.$pusher.channels[name] = Vue.prototype.$pusher.socket.subscribe(`${name}`)
    }
    else{
      Vue.prototype.$pusher.channels[name] = Vue.prototype.$pusher.socket.subscribe(`${name}_${Vue.prototype.$pusher.tenantApiKey}`)
    }
    
}

export const registerEvent = (channelName, eventName, handler, options) => {    

    Vue.prototype.$pusher.channels[channelName].bind(eventName, handler)
    //Vue.prototype.$pusher.channels[name] = Vue.prototype.$pusher.socket.subscribe(`${name}_${Vue.prototype.$pusher.tenantApiKey}`)
}
